import { IDraftStateType } from "./types";
import { RoomDraft } from "../../proto/Global_pb";
import { createReducer } from "@reduxjs/toolkit";
import { clearDraft, setDraftRoom, setDrafts, setDraftText } from "./actions";

const initialState: IDraftStateType = {};

export const draftReducers = createReducer(initialState, (builder) => {
  builder
    .addCase(setDraftText, (state, action) => {
      const prevRoomDraft: RoomDraft.AsObject = state[action.payload.roomId] || {
        replyTo: "",
        message: "",
        draftTime: 0,
      };
      const replyTo = action.payload.draft?.replyTo;
      const newDraft: Partial<RoomDraft.AsObject> = {
        ...action.payload.draft,
        replyTo: replyTo === "0" ? undefined : replyTo,
      };
      state[action.payload.roomId] = {
        ...prevRoomDraft,
        ...newDraft,
      };
    })
    .addCase(setDrafts, (state, action) => {
      state = {
        ...state,
        ...action.payload,
      };
    })
    .addCase(setDraftRoom, (state, action) => {
      return action.payload;
    })
    .addCase(clearDraft, (state, action) => {
      delete state[action.payload];
    });
});
